/* eslint-disable react/forbid-prop-types */
import React, {useEffect, useLayoutEffect} from 'react';
import PropTypes from 'prop-types';
import {Card, CardContent, CardTitlePrimary, Message} from '@design-system-coopeuch/web';
import {FuturaTarjetaWrapper} from './styles';
import {agregarformatoPesos} from '../../../../utils';
import {properties} from '../../../../utils/properties';

const TarifaInfo = ({ tarifaRef, dataComisiones, UFValor }) => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

   const formatoUF = (UF) =>{
      const formatoArray = UF.toString().split(".");
      const pesos = agregarformatoPesos(formatoArray[0]);
      const decimales = formatoArray[1];
      const UFFormateada = `${pesos},${decimales}`;
      return UFFormateada;
   }

  const {
    mantencionMensual,
    mantencionAnual,
  } = dataComisiones;

  useEffect(() => {
    tarifaRef.current = true;
    return () => {
      tarifaRef.current = false;
    };
  }, []);

  return (
    <FuturaTarjetaWrapper>
      <Card className="card-class-dos">
        <div>
          <CardTitlePrimary title="Somos transparentes, conoce las tarifas" />
        </div>
        <CardContent>
          <div className="contenedor-tarifas">
            <div>
              <div className="tituloTarifas">
                <b>{properties.futuratarjeta.Tarifas.titulo2}</b>
                <b className="cantidadUF">{` $${agregarformatoPesos(mantencionAnual)}* (${mantencionMensual})`}</b>
              </div>
              <div className="p-info">
                <p>
                  {properties.futuratarjeta.Tarifas.infoTarifas2}
                  <b> pagas $0.</b>
                </p>
              </div>
            </div>
          </div>
          <div className="div-mensaje">
            <Message title={properties.futuratarjeta.Mensaje(`$${formatoUF(UFValor)}`)} type="info" />
          </div>
        </CardContent>
      </Card>
    </FuturaTarjetaWrapper>
  );
};

TarifaInfo.propTypes = {
  tarifaRef: PropTypes.objectOf(PropTypes.any).isRequired,
  dataComisiones: PropTypes.objectOf(PropTypes.any),
  UFValor: PropTypes.number
};

TarifaInfo.defaultProps = {
  dataComisiones: [],
  UFValor: 0
};

export default TarifaInfo;
